module.exports = __webpack_public_path__ + "img/basket.648f1fbf.svg";